import { render, staticRenderFns } from "./newform-anggota.vue?vue&type=template&id=25e64464&scoped=true"
import script from "./newform-anggota.vue?vue&type=script&lang=js"
export * from "./newform-anggota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e64464",
  null
  
)

export default component.exports